import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 1. Import hook
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Box,
} from '@mui/material';
import { IconAdjustments, IconPencil, IconMessageCircle } from '@tabler/icons-react';

// Reusable Card component for a clean layout
const PlannerOptionCard = ({ to, title, description, buttonText, icon }) => (
  <Grid item size={{ xs: 12, sm: 6, md: 4 }} sx={{ marginTop: '25px' }}> {/* Corrected grid props */}
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: 6,
        },
      }}
    >
      <CardContent sx={{ flexGrow: 1, p: 4 }}>
        <Box sx={{ color: 'primary.main', mb: 2 }}>
          {icon}
        </Box>
        <Typography variant="h5" component="h2" gutterBottom fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
      <CardActions sx={{ p: 4, pt: 0 }}>
        <Button
          component={Link}
          to={to}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: '#D4A259',
            '&:hover': { backgroundColor: '#b88b4a' },
          }}
        >
          {buttonText}
        </Button>
      </CardActions>
    </Card>
  </Grid>
);

const TripPlannerLanding = () => {
  const { t } = useTranslation(); // 2. Initialize translation function

  // 3. Define the options array inside the component to use the `t` function
  const options = [
    {
      to: '/plan-your-trip/customize',
      title: t('planner_option1_title'),
      description: t('planner_option1_description'),
      buttonText: t('planner_option1_button'),
      icon: <IconAdjustments size={48} stroke={1.5} />,
    },
    {
      to: '/plan-your-trip/build',
      title: t('planner_option2_title'),
      description: t('planner_option2_description'),
      buttonText: t('planner_option2_button'),
      icon: <IconPencil size={48} stroke={1.5} />,
    },
    {
      to: '/plan-your-trip/consult',
      title: t('planner_option3_title'),
      description: t('planner_option3_description'),
      buttonText: t('planner_option3_button'),
      icon: <IconMessageCircle size={48} stroke={1.5} />,
    },
  ];

  return (
    <Box sx={{ py: 12, backgroundColor: 'grey.50' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h2" component="h1" fontWeight="bold" gutterBottom>
            {t('planner_landing_headline')}
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '700px', mx: 'auto' }}>
            {t('planner_landing_subheadline')}
          </Typography>
        </Box>
        <Grid container spacing={4}>
          {options.map((option) => (
            <PlannerOptionCard key={option.title} {...option} />
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TripPlannerLanding;